import React from "react";
import newAbt from "./assets/newabt.png";


const AboutUs = () => {
  return (
    <>
      {/* HERO SECTION */}
      <section className="about-hero d-flex align-items-center">
        <div className="about-hero-overlay"></div>
        <div className="container-fluid container-xl px-4 px-md-3">
          <h1 className="display-5 fw-bold text-white mb-1">About Tokenly</h1>
          <p className="text-light mb-0">
            Revolutionizing the patient waiting experience.
          </p>
        </div>
      </section>

      <section id="our-story" className="py-5">
        <div className="container-fluid container-xl px-4 px-md-3">
          <div className="row align-items-center gx-5">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src={newAbt}
                alt="Aesthetic representing digital queueing or healthcare"
                className="img-fluid rounded shadow-lg w-100"
              />
            </div>
            <div className="col-lg-6">
              <h6 className="text-tokenly-primary fw-bold text-uppercase mb-2">
                Our Story
              </h6>
              <h2 className="display-6 fw-bold text-dark mb-4">
                Pioneering Seamless Patient Journeys
              </h2>

              <p className="lead text-dark mb-4">
                Tokenly was born out of a simple but powerful idea: no one
                should have to wait endlessly or uncomfortably for their
                healthcare appointment. We saw the frustration of crowded clinic
                lobbies and the wasted time for both patients and doctors.
              </p>

              <h3 className="h4 fw-bold text-dark mb-3">Our Mission</h3>
              <p className="text-secondary mb-4">
                Our mission is to digitize the entire OPD experience, providing
                patients with real-time, predictable waiting information so they
                can use their time effectively. For clinics, we aim to
                streamline operations, enhance service quality, and eliminate
                reception crowding.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="vision-values" className="py-5 bg-light">
        <div className="container-fluid container-xl px-4 px-md-3">
          <div className="row gx-5">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h3 className="h4 fw-bold text-dark mb-3">Our Vision</h3>
              <p className="text-secondary">
                To be the leading global platform for digital queue management
                in healthcare, setting a new standard for patient-centric
                service, efficiency, and operational excellence in clinics
                worldwide. We envision a future where all healthcare visits are
                smooth, predictable, and stress-free.
              </p>
            </div>
            <div className="col-lg-6">
              <h3 className="h4 fw-bold text-dark mb-3">Core Values</h3>
              <ul className="list-unstyled">
                <li className="d-flex align-items-start mb-2">
                  <i className="fa-solid fa-square-check text-tokenly-primary me-2 mt-1"></i>
                  <span>
                    <strong>Efficiency:</strong> Optimizing every minute for
                    doctors and patients.
                  </span>
                </li>
                <li className="d-flex align-items-start mb-2">
                  <i className="fa-solid fa-square-check text-tokenly-primary me-2 mt-1"></i>
                  <span>
                    <strong>Transparency:</strong> Providing clear, real-time
                    status updates.
                  </span>
                </li>
                <li className="d-flex align-items-start mb-2">
                  <i className="fa-solid fa-square-check text-tokenly-primary me-2 mt-1"></i>
                  <span>
                    <strong>Care:</strong> Improving the overall well-being and
                    experience of the patient.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="why-choose-us" className="py-5">
        <div className="container-fluid container-xl px-4 px-md-3">
          <h6 className="text-tokenly-primary fw-bold text-uppercase text-center mb-2">
            The Tokenly Advantage
          </h6>
          <h2 className="display-6 fw-bold text-dark text-center mb-5">
            Why Choose Tokenly?
          </h2>

          <div className="row justify-content-center">
            <div className="col-md-10">
              <ul className="list-unstyled row about-feature-list">
                <li className="col-md-6 mb-4">
                  <div className="d-flex align-items-start">
                    <i className="fa-solid fa-clock text-tokenly-primary me-3 feature-icon"></i>
                    <div>
                      <h5 className="fw-bold text-dark">
                        Zero Wait Time Anxiety
                      </h5>
                      <p className="text-secondary mb-0">
                        Patients get accurate token status updates via the app,
                        eliminating the need to wait at the clinic and reducing
                        stress.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="col-md-6 mb-4">
                  <div className="d-flex align-items-start">
                    <i className="fa-solid fa-handshake text-tokenly-primary me-3 feature-icon"></i>
                    <div>
                      <h5 className="fw-bold text-dark">
                        Improved Clinic Efficiency
                      </h5>
                      <p className="text-secondary mb-0">
                        By streamlining the queue, doctors can manage their time
                        better and focus purely on patient care, not queue
                        management.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="col-md-6 mb-4">
                  <div className="d-flex align-items-start">
                    <i className="fa-solid fa-mobile-screen-button text-tokenly-primary me-3 feature-icon"></i>
                    <div>
                      <h5 className="fw-bold text-dark">
                        100% Digital Experience
                      </h5>
                      <p className="text-secondary mb-0">
                        Our system is built on modern, robust technology,
                        providing a smooth, reliable, and completely paperless
                        token generation experience.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="col-md-6 mb-4">
                  <div className="d-flex align-items-start">
                    <i className="fa-solid fa-user-shield text-tokenly-primary me-3 feature-icon"></i>
                    <div>
                      <h5 className="fw-bold text-dark">
                        Reduced Crowding &amp; Risk
                      </h5>
                      <p className="text-secondary mb-0">
                        Our system naturally reduces crowding in waiting areas,
                        making the environment safer for everyone, which is
                        especially important in healthcare.
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
